import http from "./http";

function get_escalation_list(data) {
  return http.post(`escalationList`, data);
}

function add_escalation(data) {
  return http.post(`saveEscalation`, data);
}

function delete_escalation(data) {
  return http.post(`delete_Escalation`, data);
}

function update_escalation(data) {
  return http.post(`update_Escalation`, data);
}

function fetch_place_data_details(data) {
  return http.post(
    `escalation_last_record`,
    data
  );
}

const EscalationService = {
  get_escalation_list,
  add_escalation,
  delete_escalation,
  update_escalation,
  fetch_place_data_details,
};

export default EscalationService;
// ====================================
